import { createFileRoute } from "@tanstack/react-router";

import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import TransactionRewardList from "@/modules/recognition/admin/components/TransactionRewardList";
import { fetchTransactionRewardsQueryOptions } from "@/modules/recognition/admin/services";

export const Route = createFileRoute(
  "/admin/_panel/_recognition/recognition/transactions/rewards",
)({
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(
      context.user,
      "recognition.recognition-transaction-reward.view",
    );

    return {
      crumb: [
        {
          label: context.t("Rewards Report", { ns: "recognition.admin" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.prefetchQuery(
      fetchTransactionRewardsQueryOptions(),
    ),
  component: RouteComponent,
});

function RouteComponent() {
  return <TransactionRewardList />;
}
